import Exception from './Exception'

export default class IllegalArgumentException extends Exception { }
